import { Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import CustomInput from "../CustomInput";
import { Button } from "../ui/button";
import { getCustomizationValue, showSuccessToast } from "src/lib/utils";
import { useAuth } from "src/providers/AuthProvider";
import { createSubAccount, editSubAccount } from "src/api/subAccount";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { usePortalContext } from "src/context/PortalContext";

const validationSchema = Yup.object().shape({
	firstname: Yup.string().required(),
	lastname: Yup.string().required(),
	othername: Yup.string(),
	idNo: Yup.string(),
	customer_id: Yup.string().required(),
	businessUuid: Yup.string().required(),
});

const AddSubAccount = ({ customer_id, subAccount }) => {
	const { user } = useAuth();
	const queryClient = useQueryClient();
	const closePortal = usePortalContext();

	const initialValues = {
		uuid: subAccount?.uuid ?? undefined,
		firstname: subAccount?.firstname ?? "",
		lastname: subAccount?.lastname ?? "",
		othername: subAccount?.othername ?? "",
		idNo: subAccount?.idNo ?? "",
		customer_id: subAccount?.customer_id ?? customer_id,
		businessUuid: user?.business_uuid,
	};

	const { mutate, isLoading } = useMutation(subAccount ? editSubAccount : createSubAccount, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			queryClient.invalidateQueries(["customers"]);
			closePortal();
		},
	});
	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
			{({ values, handleChange, handleSubmit }) => (
				<form onSubmit={handleSubmit} className="tw-grid tw-gap-4">
					<CustomInput
						label="First Name"
						name="firstname"
						type="text"
						placeholder="First Name"
						value={values.firstname}
						onChange={handleChange}
					/>
					<CustomInput
						label="Last Name"
						name="lastname"
						type="text"
						placeholder="Last Name"
						value={values.lastname}
						onChange={handleChange}
					/>
					<CustomInput
						label="Other Name (optional)"
						name="othername"
						type="text"
						placeholder="Other Name"
						value={values.othername}
						onChange={handleChange}
					/>
					<CustomInput
						label="Id Number (optional)"
						name="idNo"
						type="text"
						placeholder="Id Number (optional)"
						value={values.idNo}
						onChange={handleChange}
					/>
					<Button disabled={isLoading} className="mt-2">
						Add {getCustomizationValue(user, "sub_account_label", true)}
					</Button>
				</form>
			)}
		</Formik>
	);
};

export default AddSubAccount;
